import React from "react";
import { View, TouchableOpacity, Text } from "react-native";
import { menuScreenStyles as styles } from "../components/shared/styles/styles";

interface QuantityControlProps {
  quantity: number;
  handleAdd: () => void;
  handleQuantityChange: (change: number) => void;
}

export const QuantityControl: React.FC<QuantityControlProps> = ({
  quantity,
  handleAdd,
  handleQuantityChange,
}) =>
  quantity === 0 ? (
    <TouchableOpacity onPress={handleAdd} style={styles.menuAddBtn}>
      <Text style={styles.addButtonText}>ADD</Text>
    </TouchableOpacity>
  ) : (
    <View style={styles.menuAddBtn}>
      <TouchableOpacity
        style={{ width: "30%" }}
        onPress={() => handleQuantityChange(-1)}
      >
        <Text style={styles.addButtonText}>-</Text>
      </TouchableOpacity>
      <Text style={[styles.addButtonText, { width: "30%" }]}>{quantity}</Text>
      <TouchableOpacity
        style={{ width: "30%" }}
        onPress={() => handleQuantityChange(1)}
      >
        <Text style={styles.addButtonText}>+</Text>
      </TouchableOpacity>
    </View>
  );
